import request from '../utils/http'

// 游戏练习 - 作业下发确认
export function getPracticeIssue ({
  ids
} = {}) {
  return request({
    url: 'api/miniprogram/square/get-users-unlocked',
    method: 'get',
    params: {
      ids
    }
  })
}

// 游戏练习 - 作业下发确认 解锁订单
export function getPracticeIssueOrder ({
  id
} = {}) {
  return request({
    url: `api/student/exercise/orders/${id}`,
    method: 'put',
    data: {
      status: 2
    }
  })
}

// 游戏练习 - 作业下发确认 获取是否支付成功
export function getPracticePaySuccess ({
  id
}) {
  return request({
    url: `api/student/exercise/orders/${id}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/practice.js